import { ChangeEvent, useState, useEffect, memo, ReactNode } from "react";
import "./index.scss";
import { FieldAttributes, useField, useFormikContext } from "formik";
import { IResponseField } from "../../../model/reactField";

interface Props {
    label: ReactNode;
    disabled: boolean;
    hidden: boolean;
    backEndName?: string;
    setFieldToUpdate?: (fieldToUpdate: IResponseField) => void;
    fieldValue: boolean;
    onChangeListener?: (val: any) => void;
    additionalInfo?: any;
    contextPath?: string;
    payerIsPersonValue?: any
}

declare type CheckboxProps = FieldAttributes<Props>;

export const CheckboxOld = memo((props: CheckboxProps) => {
    const { name, label, disabled, payerIsPersonValue, hidden, backEndName, setFieldToUpdate, fieldValue, onChangeListener, additionalInfo, contextPath } = props;

    const [field, meta, helpers] = useField({ name });

    const { handleBlur } = useFormikContext();

    const [value, setValue] = useState<boolean>(fieldValue);

    useEffect(() => {
        setValue(fieldValue)
    }, [fieldValue])

    const fieldValueFromQuotation = field.value || false;

    const validationError = meta.touched && meta.error || '';

    if (fieldValueFromQuotation !== value && backEndName !== 'payerIsPerson') {
        helpers.setValue(value);
        if (setFieldToUpdate && backEndName) {
            setFieldToUpdate({ name: backEndName, value: value, contextPath: contextPath || 'mainContract' });
        }
    }

    const handleChange = async (_: ChangeEvent<HTMLInputElement>, res) => {
        helpers.setValue(res);
        setValue(res)
        if (setFieldToUpdate && backEndName) {
            setFieldToUpdate({ name: backEndName, value: res, contextPath: contextPath || 'mainContract' });
        }
        onChangeListener?.(res);
    };

    return (
        <div className={`checkbox`} hidden={hidden}>
            <div className={'checkbox__items'}>
                <input type={'checkbox'}
                    id={name}
                    name={backEndName}
                    checked={payerIsPersonValue !== undefined ? payerIsPersonValue : value}
                    disabled={disabled}
                    className={"checkbox__input"}
                    onChange={(event) => handleChange(event, !value)}
                    onBlur={handleBlur} />

                {label && (
                    <label htmlFor={name} className={'checkbox__label'}>{label}
                        {additionalInfo}
                    </label>
                )}
            </div>
            {validationError && (
                <div className='checkbox__error'>{validationError}</div>
            )}
        </div>
    )
});